<template>
  <v-card
    color=" ma-0 pa-0"
    class="sign-in-form-card elevation-0 bg-primary"
    dark
  >
    <!-- <h2 class="sign-in-name">{{ name }}</h2> -->
    <!-- <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          dark
          v-model="email"
          :rules="emailRules"
          prepend-icon="mdi-account"
          label="E-mail"
          required
          class="sign-in-input"
        ></v-text-field>
        <v-text-field
          v-model="password"
          :rules="passwordRules"
          prepend-icon="mdi-lock"
          label="Password"
          type="password"
          required
          dark
          class="sign-in-input"
        ></v-text-field>
      </v-form>
    </v-card-text> -->
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="!valid || pLoading"
        color="primary"
        class="mr-4"
        @click="validate"
        :loading="pLoading"
      >
        Sign In
      </v-btn>
    </v-card-actions> -->

    <v-card-actions>
      <v-btn
        light
        class="google-btn full-width ma-0 "
        @click="() => $emit('onGoogle')"
      >
        <v-icon color="primary" class="left mr-4">mdi-google</v-icon>
        Continue with Google
      </v-btn>
    </v-card-actions>
  </v-card>
</template>



<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: "Customer Portal",
    },
  },
  data() {
    return {
      pLoading: this.loading,

      valid: true,
      password: "",
      email: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 8) || "Password must be more than 8 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },

  methods: {
    validate() {
      const t = this.$refs.form.validate();
      if (t)
        this.$emit("onSubmit", {
          password: this.password,
          email: this.email,
        });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  watch: {
    loading(newVal) {
      this.pLoading = newVal;
    },
  },
};
</script>




<style lang="scss" scoped>
.sign-in-form-card {
  .sign-in-name {
    display: flex;
    justify-content: center;

    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 20px;
  }
  .google-btn {
    height: 64px;
  }
}
</style>